module.exports = __webpack_public_path__ + "static/deacon-king-kong-be35ba6090f38fd530d630cff71fd133.jpg";